import { render, staticRenderFns } from "./FeaturedChallengeSmall.vue?vue&type=template&id=681af0e0&scoped=true&lang=pug&"
import script from "./FeaturedChallengeSmall.vue?vue&type=script&lang=js&"
export * from "./FeaturedChallengeSmall.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedChallengeSmall.vue?vue&type=style&index=0&id=681af0e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681af0e0",
  null
  
)

export default component.exports